module.exports = __webpack_public_path__ + "img/LOGO-ARIANE-BLANC.89420da4.png";